import type { ReactNode } from "react";
import "../../../Css/Common/Modals/GlassModalHeader.css";

export type GlassModalHeaderProps = {
  kicker?: string;
  title: string;
  /** Renders to the left of the title (e.g. action type icon). */
  titlePrefix?: ReactNode;
  /** Renders to the right of the title (e.g. priority badge). */
  titleSuffix?: ReactNode;
  subtitle?: ReactNode;
  /** Optional metadata row rendered below the subtitle. */
  meta?: ReactNode;
  /** Renders before the close button (e.g. Mark done). */
  trailingActions?: ReactNode;
  onClose: () => void;
  closeAriaLabel?: string;
  variant?: "default" | "danger";
  /** Places title and subtitle on one row when space allows. */
  inlineTitleSubtitle?: boolean;
};

export function GlassModalHeader({
  kicker = "My accounts",
  title,
  titlePrefix,
  titleSuffix,
  subtitle,
  meta,
  trailingActions,
  onClose,
  closeAriaLabel = "Close",
  variant = "default",
  inlineTitleSubtitle = false,
}: GlassModalHeaderProps) {
  const baseHeaderClass =
    variant === "danger"
      ? "activityFilter_popover_header glassModal_header glassModal_header--danger"
      : "activityFilter_popover_header glassModal_header";
  const headerClass = `${baseHeaderClass}${
    inlineTitleSubtitle ? " glassModal_header--inlineTitleSubtitle" : ""
  }`;

  return (
    <div className={headerClass}>
      <div className="activityFilter_popover_headerText">
        {kicker ? <p className="activityFilter_popover_kicker">{kicker}</p> : null}
        {titlePrefix != null || titleSuffix != null ? (
          <div className="activityFilter_popover_titleRow">
            {titlePrefix}
            <span className="activityFilter_popover_titleText">{title}</span>
            {titleSuffix ? (
              <span className="activityFilter_popover_titleSuffix">{titleSuffix}</span>
            ) : null}
          </div>
        ) : (
          <p className="activityFilter_popover_title">{title}</p>
        )}
        {subtitle ? (
          <p className="activityFilter_popover_subtitle">{subtitle}</p>
        ) : null}
        {meta ? <div className="glassModal_headerMeta">{meta}</div> : null}
      </div>
      <div className="activityFilter_popover_headerActions">
        {trailingActions}
        <button
          type="button"
          className="activityFilter_popover_close"
          onClick={onClose}
          aria-label={closeAriaLabel}
        >
          <span className="fa-solid fa-xmark" aria-hidden />
        </button>
      </div>
    </div>
  );
}
